document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const viewport = carousel.querySelector('[data-carousel-viewport]');
  const section = carousel.closest('.featured');
  const previous = section?.querySelector('[data-carousel-previous]');
  const next = section?.querySelector('[data-carousel-next]');
  if (!viewport || !previous || !next) return;
  const update = () => {
    previous.disabled = viewport.scrollLeft <= 1;
    next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
  };
  const move = (direction) => viewport.scrollBy({ left: direction * viewport.clientWidth * 0.9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  viewport.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
});
